import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  quote: 'Dejé de sentirme perdido. Ahora sé qué hacer y cuándo hacerlo.',
  name: 'Laura M.',
  role: 'Hija y cuidadora'
}, {
  quote: 'Pasamos de discutir todo… a organizarnos mejor como familia.',
  name: 'Andrés R.',
  role: 'Hijo'
}, {
  quote: 'Lo que más me ayudó fue tener un sistema claro, no improvisar.',
  name: 'Carolina V.',
  role: 'Hija'
}];
export function Testimonials() {
  return <section className="bg-brand-dark py-5 px-5" data-id="element-295">
      <div className="max-w-xl mx-auto" data-id="element-296">
        <h2 className="text-2xl md:text-3xl font-bold text-center text-white mb-8" data-id="element-297">
          💬 ¿Qué dicen las familias que ya usan el Megapack?
        </h2>

        <div className="space-y-4" data-id="element-298">
          {testimonials.map((t, i) => <div key={i} className="bg-gray-900 border border-gray-800 p-5 rounded-xl" data-id="element-299">
              <div className="flex gap-0.5 mb-3" data-id="element-300">
                {[...Array(5)].map((_, j) => <Star key={j} size={14} className="fill-brand-yellow text-brand-yellow" data-id="element-301" />)}
              </div>
              <p className="text-gray-300 italic text-sm mb-3 leading-relaxed" data-id="element-302">
                "{t.quote}"
              </p>
              <div data-id="element-303">
                <p className="font-bold text-white text-sm" data-id="element-304">{t.name}</p>
                <p className="text-xs text-gray-500" data-id="element-305">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}